import { render, staticRenderFns } from "./PoliticaOperativaActivarComponent.vue?vue&type=template&id=c5de417e&"
import script from "./PoliticaOperativaActivarComponent.vue?vue&type=script&lang=js&"
export * from "./PoliticaOperativaActivarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
